import {
  ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN_SUCCESS,
  ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN_FAILED,
  RESET_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN,
  LOADING_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN,
  NETWORK_ERROR_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN:
      return (state = initialState);
    default:
      return state;
  }
};
